<template>
  <div class="home">
    <!-- <v-parallax :src="require('../../public/sunset6.jpg')" height="800">
        <h2 class="homeText">Mind Body Health Center is a Clinical Therapy Practice in New Providence, NJ.</h2>
    </v-parallax> -->
    <v-img :src="require('../../public/sunset.jpg')" height="800">
      <h2 class="imgText tc">Mind Body Health Center is a Pyschotherapy and Counseling Practice in New Providence, NJ.</h2>
    </v-img>
  </div>
</template>

<script>
export default {
  name: "Home",
}
</script>

<style>

.home {
  color: black;
  margin: 20px;
}

.homeText {
  /* padding: 20px; */
  /* color: black; */
}

.imgText {
  margin-top: 40px;
  color: white;
  padding: 20px;
}

</style>
